/**
 * Sanitizes HTML content for accessibility compliance (WCAG 4.1.2)
 * Fixes common issues in CMS-generated content:
 * - Empty anchor links (links with href but no text content)
 *
 * Works on both server and client side using regex-based approach.
 */
export const useSanitizeHtml = (html: string): string => {
    if (!html) return html

    // Fix empty mailto: links - pattern: <a href="mailto:email@example.com"></a>
    // Replace with <a href="mailto:email@example.com" aria-label="Odoslať email na email@example.com">email@example.com</a>
    let result = html.replace(
        /<a\s+([^>]*href=["']mailto:([^"']+)["'][^>]*)>\s*<\/a>/gi,
        (_, attrs, email) => {
            const cleanAttrs = attrs.replace(/aria-label=["'][^"']*["']/gi, '')
            return `<a ${cleanAttrs} aria-label="Odoslať email na ${email}">${email}</a>`
        }
    )

    // Fix empty tel: links - pattern: <a href="tel:+421123456789"></a>
    result = result.replace(
        /<a\s+([^>]*href=["']tel:([^"']+)["'][^>]*)>\s*<\/a>/gi,
        (_, attrs, phone) => {
            const cleanAttrs = attrs.replace(/aria-label=["'][^"']*["']/gi, '')
            return `<a ${cleanAttrs} aria-label="Zavolať na ${phone}">${phone}</a>`
        }
    )

    // Fix empty http/https links - pattern: <a href="https://example.com"></a>
    result = result.replace(
        /<a\s+([^>]*href=["'](https?:\/\/[^"']+)["'][^>]*)>\s*<\/a>/gi,
        (_, attrs, url) => {
            const cleanAttrs = attrs.replace(/aria-label=["'][^"']*["']/gi, '')
            try {
                const urlObj = new URL(url)
                return `<a ${cleanAttrs} aria-label="Odkaz na ${urlObj.hostname}">${urlObj.hostname}</a>`
            } catch {
                return `<a ${cleanAttrs} aria-label="Externý odkaz">Odkaz</a>`
            }
        }
    )

    return result
}
